'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: all 0.2s linear;\n  max-height: ", ";\n  overflow: hidden;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = styled__default['default'].div(_templateObject(), function (props) {
  return props.show ? "".concat(window.innerHeight, "px") : '0';
}, index.styleEngine);

var Collapsible = function Collapsible(props) {
  return /*#__PURE__*/React__default['default'].createElement(Wrapper, props);
};

Collapsible.propTypes = {
  children: PropTypes__default['default'].node,
  show: PropTypes__default['default'].bool
};

exports.default = Collapsible;
